// src/components/Hero.jsx
import React, { useState, useRef } from "react";
import Slider from "react-slick";
import { apiResource, appUrl } from "../../../utils";

export default function Hero({ featuredEvents = [] }) {
  const [currentIndex, setCurrentIndex] = useState(0);
  const mainSliderRef = useRef(null);

  if (!featuredEvents || featuredEvents.length === 0) return null;

  const mainSettings = {
    infinite: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: true,
    speed: 500,
    swipe: true,
    beforeChange: (_oldIndex, nextIndex) => setCurrentIndex(nextIndex),
  };

  const bottomSettings = {
    infinite: false,
    slidesToShow: 6,
    slidesToScroll: 3,
    arrows: false,
    swipeToSlide: true,
    responsive: [
      {
        breakpoint: 1200,
        settings: { slidesToShow: 5, slidesToScroll: 3 },
      },
      {
        breakpoint: 992,
        settings: { slidesToShow: 4, slidesToScroll: 2 },
      },
    ],
  };

  const handlePrev = () => {
    if (mainSliderRef.current) mainSliderRef.current.slickPrev();
  };

  const handleNext = () => {
    if (mainSliderRef.current) mainSliderRef.current.slickNext();
  };

  return (
    <section className="hero-section position-relative">
      {/* ==== SLIDER PRINCIPAL ==== */}
      <Slider ref={mainSliderRef} {...mainSettings}>
        {featuredEvents.map((event, index) => (
          <div key={event.id || index}>
            <div
              className="hero-main-slide"
              style={{
                "--img-desktop": `url("${apiResource({ url: event.banner_large_event })}")`,
                "--img-tablet": `url("${apiResource({ url: event.banner_tablet_event })}")`,
                "--img-mobile": `url("${apiResource({ url: event.banner_mobile_event })}")`,
              }}
            >
              <div className="hero-main-overlay" />
              <div className="container hero-main-inner">
                <div className="hero-main-content text-center text-white mx-auto">
                  {/* Etiqueta superior */}
                  <p className="hero-tag text-uppercase mb-2">
                    {event.name_type_event || "Evento destacado"}
                  </p>

                  {/* Título principal */}
                  <h2 className="hero-title mb-3">
                    {event.name_event}
                  </h2>

                  {/* Lugar (ajusta el campo a tu modelo) */}
                  {(event.location_event) && (
                    <p className="hero-subtitle mb-4">
                      {event.location_event}
                    </p>
                  )}

                  {/* Fecha / hora */}
                  <p className="hero-datetime mb-4">
                    {event.date_formmatted_event}{" "}
                    {event.time_formmatted_event && (
                      <>• {event.time_formmatted_event}</>
                    )}
                  </p>

                  {/* CTA */}
                  <a href={appUrl({ url: event.slug_event_formatted })}
                    className="btn btn-outline-light hero-cta text-uppercase fw-bold"
                  >
                    Comprar boletos
                  </a>
                </div>
              </div>
            </div>
          </div>
        ))}
      </Slider>

      {/* Flechas sobre el banner */}
      <button
        type="button"
        className="hero-arrow hero-arrow-left"
        onClick={handlePrev}
      >
        <i className="fas fa-chevron-left" />
      </button>

      <button
        type="button"
        className="hero-arrow hero-arrow-right"
        onClick={handleNext}
      >
        <i className="fas fa-chevron-right" />
      </button>

      {/* ==== FRANJA INFERIOR (solo desktop / tablets) ==== */}
      <div className="hero-bottom-bar d-none d-md-block">
        <div className="container">
          <Slider {...bottomSettings}>
            {featuredEvents.map((event, index) => (
              <div key={event.id || `thumb-${index}`}>
                <button
                  type="button"
                  className={
                    "hero-thumb-card text-start w-100 " +
                    (index === currentIndex ? "active" : "")
                  }
                  onClick={() => {
                    if (mainSliderRef.current) {
                      mainSliderRef.current.slickGoTo(index);
                    }
                    setCurrentIndex(index);
                  }}
                >
                  <div className="hero-thumb-title">
                    {event.name_event}
                  </div>
                  <div className="hero-thumb-meta">
                    {event.date_formmatted_event || "Varias fechas"}
                  </div>
                </button>
              </div>
            ))}
          </Slider>
        </div>
      </div>
    </section>
  );
}
